import React, { useState, useEffect } from "react";
import { Text, View, StyleSheet, Platform } from "react-native";

import Dialog from "../../common/dialog";
import AppTheme from "../../AppTheme";

import ImageComponent from "../../common/ImageComponent";
import ManaButton from "../../common/ManaButton";
import { isWeb, navigate } from "../../../../helpers/utils";

export default function TutorialsHomeCard({
  controller,
  isOpen = false,
  loadTutorial = () => {},
}) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  useEffect(() => {
    setIsDialogOpen(isOpen);
  }, [isOpen]);

  const onButtonPress = () => {
    const action = {
      action: "save",
      target: "scheduled_call",
    };

    controller.tracking.track("Schedule Call");
    controller.cardAction(action);
    navigate(controller, "rn:appointment");
  };

  const mariWidth = 89 * (isWeb ? 1 : 0.7);
  const mariHeight = 116 * (isWeb ? 1 : 0.7);

  return (
    <>
      {isDialogOpen ? (
        <Dialog.Container>
          <View style={styles.container}>
            <View style={styles.card}>
              {/* Header */}
              <View style={styles.header}>
                <Text style={styles.title}>Welcome</Text>
              </View>

              {/* Content */}
              <View style={[styles.cardContent]}>
                <ImageComponent
                  image={require("../../../../assets/home/CheeringMari.png")}
                  styles={[
                    styles.image,
                    {
                      width: mariWidth,
                      height: mariHeight,
                      overflow: "visible",
                    },
                  ]}
                />
                <View style={styles.textContainer}>
                  <Text style={styles.cardText}>
                    I can’t wait to help you get started!
                  </Text>
                  <Text style={styles.cardDescription}>
                    Mana works best when you schedule some time to get onboarded
                    with one of our expert guides.
                  </Text>
                </View>
              </View>

              <View style={styles.buttons}>
                <ManaButton
                  onPress={loadTutorial}
                  styleText={styles.buttonText}
                  style={styles.button}
                  text={"Not now"}
                />

                <ManaButton
                  isMainButton
                  onPress={onButtonPress}
                  style={styles.button}
                  styleText={styles.buttonText}
                  text={"Schedule call"}
                />
              </View>
            </View>
          </View>
        </Dialog.Container>
      ) : null}
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    marginTop: -30,
    maxWidth: 320,
    marginHorizontal: "auto",
  },
  card: {
    backgroundColor: "#FFFFFF",
    borderRadius: 10,
    paddingBottom: 10,
    display: "flex",
    alignItems: "center",
  },
  header: {
    height: 50,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 24,
    marginBottom: 10,
  },
  title: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 26,
    lineHeight: 35,
    letterSpacing: 0.5,
    color: "#2D3142",
    zIndex: 2,
    textAlign: "center",
  },
  cardContent: {
    display: "flex",
    alignItems: "center",
    paddingHorizontal: 10,
  },
  textContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 13,
  },
  cardText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
  cardDescription: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Regular" }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
    marginTop: 12,
  },
  image: {
    width: 90,
    height: 116,
    aspectRatio: 1,
  },
  buttons: {
    marginTop: 28,
    maxWidth: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    width: "100%",
  },
  button: {
    width: "auto",
    paddingHorizontal: 20,
  },
});
